import ReceiptDashboardPage from "./pages/ReceiptDashboardPage";
import ReceiptDetailPage from "./pages/ReceiptDetailPage";

export const receiptRoutes = (prefix = "receipts") => [
  {
    name: "ReceiptDashboardPage",
    path: `${prefix}/dashboard`,
    component: ReceiptDashboardPage
  },
  {
    name: "ReceiptDetailPage",
    path: `${prefix}/:id`,
    component: ReceiptDetailPage
  }
];
